import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function AspirantsParDistrictChart() {
  const [labels, setLabels] = useState([]);
  const [dataCG, setDataCG] = useState([]);
  const [dataSYL, setDataSYL] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setErr("");
        const res = await api.get("/stats/aspirants-par-district");
        const rows = res.data || [];

        setLabels(rows.map(r => r.district_name));
        setDataCG(rows.map(r => Number(r.total_CG || 0)));
        setDataSYL(rows.map(r => Number(r.total_SYL || 0)));
      } catch (e) {
        console.error("Erreur stats districts:", e?.response || e);
        const code = e?.response?.status;
        setErr(code === 403 ? "Accès refusé (besoin rôle coordinateur_region ou admin)" : "Erreur chargement des stats");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const data = {
    labels,
    datasets: [
      { label: "Chef Guide", data: dataCG, backgroundColor: "#0d6efd" }, 
      { label: "SYL",        data: dataSYL, backgroundColor: "#6e0b14" } 
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title:  { display: true, text: "Aspirants par District (parcours CG / SYL)" }
    }
  };

  if (loading) return <div className="card p-3">Chargement…</div>;
  if (err)     return <div className="alert alert-danger">{err}</div>;
  if (labels.length === 0) return <div className="card p-3">Aucune donnée à afficher.</div>;

  return (
    <div className="card shadow-sm mt-4">
      <div className="card-body">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}
